// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9ebba4e8","701":"5573b25b","703":"5f1de7a2"}[chunkId] + ".chunk.js";
};